export default __webpack_public_path__ + "static/media/docker.74ac8169.png";